export default {
  LOGIN: '/auth/local',
  REGISTER: '/auth/local/register',
  CONTACT: '/contact',
}
